import { faPencil, faPlus, faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useRef, useState } from 'react';
import { Button, Col, Container, Modal, Row } from 'react-bootstrap';
import { CSSTransition } from 'react-transition-group';
import { useSelector } from "react-redux";
import './style.scss';
import { faTrashCanList, faXmark } from '@fortawesome/pro-regular-svg-icons';
import { DashboardServiceApi } from "../../../../services/watchlist/api";
import { Configuration } from "../../../../services/watchlist/configuration";
import lodash from 'lodash';
import { Toast } from 'primereact/toast';
import { ConfirmDialog } from "primereact/confirmdialog";
import { APIControl } from '../../../../helpers/APIControl';
import { useTranslation } from "react-i18next";
import { de } from 'date-fns/locale';
import { useDispatch } from 'react-redux';
import { setActiveListBarItem } from '../../../../stores/watchlist';

export default function ListBar(props) {
  const watchlistApi = new DashboardServiceApi(new Configuration({ basePath: process.env.REACT_APP_WATCHLIST_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_WATCHLIST_API_BASE_PATH));
  const list = useSelector((state) => state.watchlist?.list);
  const [selectedWatchListId, setSelectedWatchListId] = useState(undefined);
  const [selectedWatchListName, setSelectedWatchListName] = useState(undefined);
  const [watchlistsData, setWatchlistsData] = useState([]);
  const [activeCustomListButton, setActiveCustomListButton] = useState(null);
  const [editRenameInputValue, setEditRenameInputValue] = useState(''); // Burada tanımlandı
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [editModalShow, setEditModalShow] = useState(false);
  const [deleteConfirmModalShow, setDeleteConfirmModalShow] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const toast = useRef(null);
  const { t, i18n } = useTranslation();
  const updatedList = useSelector((state) => state.watchlistTableSearchItem.updatedList);
  const language = i18n.language;
  const token = localStorage.getItem('token');
  const [defaultListPrefix, setDefaultListPrefix] = useState("predefinedxu030");
  const dispatch = useDispatch();

  useEffect(() => {
    fetchWatchlist();
  }, [props.updateListBarId, updatedList]);

  const fetchWatchlist = (newListName = "") => {
    const culture = language;
    watchlistApi.watchlistListGet(token, culture).then((res) => {
      const mappedWatchlistData = lodash.map(res.data.items, (item) => ({
        name: item.name,
        id: item.id,
        order: item.id.includes("predefinedxu030") ? 0 : 1,
        count: item.securityCount,
      })).sort((a, b) => a.order - b.order);

      setWatchlistsData(mappedWatchlistData);
      let selectedId = localStorage.getItem('selectedListBarItemIdWL');

      // If the stored selected ID is not found in the fetched lists (e.g., it was deleted), fall back to the first predefined list
      if (selectedId) {
        const existsInData = mappedWatchlistData.some(item => item.id === selectedId);
        if (!existsInData) {
          const fallbackPredefined = mappedWatchlistData.find(item => item.id.startsWith('predefined'));
          if (fallbackPredefined) {
            selectedId = fallbackPredefined.id;
          }
        }
      }

      // Eğer selectedId yoksa, defaultListPrefix ile başlayan ilk listeyi seç
      if (!newListName && (!selectedId || selectedId === '')) {
        const defaultList = mappedWatchlistData.find(item => item.id.startsWith('predefined'));
        if (defaultList) {
          selectedId = defaultList.id;
        } else {
          selectedId = mappedWatchlistData[0]?.id;
        }
      }

      // Eğer selectedId predefined içeriyorsa, mevcut listeler içinde ilk predefined olanı seç
      if (!newListName && selectedId && selectedId.includes('predefined')) {
        const firstPredefined = mappedWatchlistData.find(item => item.id.startsWith('predefined'));
        if (firstPredefined) {
          selectedId = firstPredefined.id;
        }
      }

      if (!newListName && selectedId) {
        localStorage.setItem('selectedListBarItemIdWL', selectedId);
        const selectedListItem = mappedWatchlistData.find(item => item.id === selectedId);

        if (selectedListItem) {
          props.selectedListBarItem(selectedId, selectedListItem.name, selectedListItem.count);
          setActiveCustomListButton(selectedId);
        }
      }
      else if (newListName) {
        const newListItem = mappedWatchlistData.find(item => item.name === newListName);
        selectedId = newListItem.id;
        localStorage.setItem('selectedListBarItemIdWL', selectedId);
        props.selectedListBarItem(selectedId, newListName, newListItem.count);
        setActiveCustomListButton(selectedId);
      }

      if (props.updateListBarId && props.updateListBarId !== "") {
        setActiveCustomListButton(props.updateListBarId);
      }
    }).catch((err) => {
      console.error("Error fetching watchlist:", err);
    });
  };

  const clickCustomListButton = (id, name, count) => {
    if (!id || !name) return;

    // Make sure we're passing count to the parent component
    localStorage.setItem('selectedListBarItemIdWL', id);
    dispatch(setActiveListBarItem({ id, name, count }));
    setActiveCustomListButton(id);
    setSelectedWatchListId(id);
    setSelectedWatchListName(name);

    // Ensure the count parameter is passed
    props.selectedListBarItem(id, name, count);
  };

  const clickEdit = (id, name, e) => {
    // Stop event propagation to prevent parent click handler from firing
    if (e) {
      e.stopPropagation();
    }

    // Set the selected watchlist id and name for edit/delete operations
    setSelectedWatchListId(id);
    setSelectedWatchListName(name);

    setEditModalShow(true);
    setEditRenameInputValue(name);
  };

  const handleChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleEditRenameChange = (e) => {
    setEditRenameInputValue(e.target.value);
  };

  const clickEditRenameWatchlist = () => {
    const prevName = selectedWatchListName;
    const newName = editRenameInputValue;
    const id = selectedWatchListId;

    watchlistApi.watchlistRenameGet(token, id, newName).then((res) => {
      if (!res.data.error) {
        toast.current.show({
          severity: 'success',
          summary: t('successful'),
          detail: t('watchlist.listRenamed', { oldName: prevName, newName: newName }),
          life: 3000,
        });
        fetchWatchlist();
        setEditModalShow(false);
      } else {
        toast.current.show({
          severity: 'error',
          summary: t('unsuccessful'),
          detail: t('error') + `: ${res.data.error}`,
          life: 3000,
        });
      }
    }).catch((err) => {
      console.error(err);
    });
  };

  const deleteWatchlistAccept = () => {
    setEditModalShow(false);

    setVisibleAlert(true);
    setAlertMessage(t('watchList.removeWatchListQuestion', { listName: selectedWatchListName }));
  };

  const confirmedDeleteListHandler = () => {
    watchlistApi.watchlistDeleteGet(token, selectedWatchListId).then((res) => {
      if (!res.data.error) {
        localStorage.removeItem('selectedListBarItemIdWL')
        toast.current.show({
          severity: 'success',
          summary: t('successful'),
          detail: t('watchlist.listDeleted', { name: selectedWatchListName }),
          life: 3000,
        });
        setSelectedWatchListId(undefined);
        setSelectedWatchListName(undefined);
        fetchWatchlist();
        setEditModalShow(false);
      } else {
        toast.current.show({
          severity: 'error',
          summary: t('unsuccessful'),
          detail: t('error') + `: ${res.data.error}`,
          life: 3000,
        });
      }
    }).catch((err) => {
      console.error(err);
    });
  };

  const confirmDeleteListCancelHandler = () => {
    setDeleteConfirmModalShow(false);
  };

  const createWatchlist = () => {
    if (inputValue === "") {
      toast.current.show({
        severity: 'warn',
        summary: t('warning'),
        detail: t('watchList.emptyListName'),
        life: 3000,
      });
      return;
    }

    // Check if a list with the same name already exists
    const listExists = watchlistsData.some(list =>
      list.name.toLowerCase() === inputValue.toLowerCase()
    );

    if (listExists) {
      toast.current.show({
        severity: 'warn',
        summary: t('warning'),
        detail: t('watchList.listAlreadyExists', { listName: inputValue }),
        life: 3000,
      });
      return;
    }

    setIsLoading(true); // Set loading to true before API call

    watchlistApi.watchlistNewGet(token, inputValue).then((res) => {
      if (!res.data.error) {
        setModalShow(false);
        toast.current.show({
          severity: 'success',
          summary: t('successful'),
          detail: t('watchList.successCreateList', { listName: inputValue }),
          life: 3000,
        });
        fetchWatchlist(inputValue);
      } else {
        // Check if error message contains "already exists"
        if (res.data.error.includes("already exists") || res.data.error.includes("already exist")) {
          toast.current.show({
            severity: 'warn',
            summary: t('warning'),
            detail: t('watchList.listAlreadyExists', { listName: inputValue }),
            life: 3000,
          });
        } else {
          toast.current.show({
            severity: 'error',
            summary: t('unsuccessful'),
            detail: t('error') + `: ${res.data.error}`,
            life: 3000,
          });
        }
      }
    }).catch((err) => {
      console.error(err);
      toast.current.show({
        severity: 'error',
        summary: t('error'),
        detail: t('errorOccurred'),
        life: 3000,
      });
    }).finally(() => {
      setIsLoading(false); // Set loading to false after API call completes
    });
  };

  return (
    <div className='list-bar-component'>
      <Toast ref={toast} position="bottom-right" />
      <ConfirmDialog
        visible={visibleAlert}
        onHide={() => setVisibleAlert(false)}
        message={alertMessage}
        header={t('warning')}
        icon="pi pi-exclamation-triangle"
        accept={confirmedDeleteListHandler}
        reject={confirmDeleteListCancelHandler}
        acceptLabel={t('yes')}
        rejectLabel={t('cancel')}
      />

      <Container className=''>
        <Row className='m-t-20'>
          {watchlistsData.map((item) => (
            <Col md="auto" key={item.id}>
              <Row>
                <div className='watchlist-buttons-col'>
                  <div
                    key={item.id}
                    className={`custom-list-buttons button roboto-bold-14 ${activeCustomListButton === item.id ? "active" : ""}`}
                    onClick={() => clickCustomListButton(item.id, item.name, item.count)}
                  >
                    <label className='title'>{item.name}</label>
                    <div className="count-circle">
                      <label className='count-label'>{item.count}</label>
                    </div>
                    {item.id.includes("predefinedxu") ? null :
                      <div className="edit-button" onClick={(e) => clickEdit(item.id, item.name, e)}>
                        <FontAwesomeIcon className="icon" icon={faPencil} />
                      </div>}
                  </div>
                </div>
              </Row>
            </Col>
          ))}

          <div className="add-button" onClick={() => setModalShow(true)}>
            <FontAwesomeIcon className='icon cursor-pointer' icon={faPlus} />
          </div>
        </Row>
      </Container>

      <CSSTransition in={deleteConfirmModalShow} timeout={300} classNames="modal" unmountOnExit>
        <Modal dialogClassName="modal-delete-confirm-list" show={deleteConfirmModalShow} aria-labelledby="contained-delete-confirm-modal-title-vcenter" animation={true} backdrop="static" keyboard={false} centered>
          <Modal.Body>
            <Row>
              <Col>
                <div className="delete-confirm-body">
                  <div className="delete-confirm-trash-icon">
                    <FontAwesomeIcon icon={faTrashCanList} />
                  </div>
                  <span className="m-t-15">{selectedWatchListName}</span>
                  <span>{t('watchList.removeWatchListQuestion')}</span>
                </div>
              </Col>
            </Row>
            <Row className="modal-delete-confirm-buttons m-t-30">
              <Col>
                <Button onClick={confirmDeleteListCancelHandler} className="cancel-btn hl-btn">{t('cancel')}</Button>
              </Col>
              <Col>
                <Button onClick={confirmedDeleteListHandler} className="hl-primary-btn hl-btn">{t('delete')}</Button>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
      </CSSTransition>

      <CSSTransition in={editModalShow} timeout={300} classNames="modal" unmountOnExit>
        <Modal dialogClassName="modal-edit-list" show={editModalShow} aria-labelledby="contained-edit-modal-title-vcenter" animation={true} backdrop={false} keyboard={false} centered>
          <Modal.Header>
            <Modal.Title id="contained-modal-title-vcenter">
              <div className="modal-header-wrap">
                <h6 className="m-0">{t('editList')}</h6>
                <div className="modal-header-close" onClick={() => setEditModalShow(false)}>
                  <FontAwesomeIcon icon={faXmark} />
                </div>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col>
                <div className="form-group">
                  <input data-testid="listName-input" type="text" value={editRenameInputValue} onChange={handleEditRenameChange} className="form-control listName-input input" id="listName-input" placeholder={t('listName')} />
                </div>
              </Col>
            </Row>
            <Button onClick={clickEditRenameWatchlist} className="modal-save-btn save-button">{t('save')}</Button>
            <Button onClick={deleteWatchlistAccept} className="modal-delete-list-btn cancel-button">{t('deleteList')}</Button>
          </Modal.Body>
        </Modal>
      </CSSTransition>

      <Modal dialogClassName="modal-create-list" show={modalShow} aria-labelledby="contained-modal-title-vcenter" animation={true} backdrop="static" keyboard={false} centered>
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            <div className="modal-header-wrap">
              <h6 className="m-0">{t('watchList.creatNewWatchList')}</h6>
              <div className="modal-header-close" onClick={() => setModalShow(false)}>
                <FontAwesomeIcon icon={faXmark} />
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              <div className="form-group" data-testid="listName-input">
                <input
                  type="text"
                  value={inputValue}
                  onChange={handleChange}
                  className="form-control input"
                  id="listName-input"
                  placeholder={t('listName')}
                  disabled={isLoading} // Disable input when loading
                />
              </div>
            </Col>
          </Row>
          <Button
            onClick={createWatchlist}
            className="modal-save-btn save-button"
            disabled={isLoading} // Disable button when loading
          >
            {isLoading ? (
              <span className="button-spinner-container">
                <FontAwesomeIcon icon={faSpinner} spin size="lg" style={{ marginRight: '8px' }} />
                {t('save')}
              </span>
            ) : (
              t('save')
            )}
          </Button>
        </Modal.Body>
      </Modal>
    </div>
  );
}

